import { CampaignsService } from './campaigns.service';

declare let angular: ng.IAngularStatic;

export default angular
  .module('sfMobile.services.campaigns', ['sfMobile.reactive-campaigns'])
  .service('campaignsService', CampaignsService).name;
